module.exports = __webpack_public_path__ + "img/ar.52a102a5.png";